import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

const state = {
  selectedCountry: {},
  countries: [],
  colorCoding: {
    0: "#ca562c",
    1: "#de8a5a",
    2: "#edbb8a",
    3: "#b4c8a8",
    4: "#70a494",
    5: "#008080",
  },
  tilesets: {
    US: {
      mapboxUrl: "mapbox://codrutaene.036lluz6",
      sourceLayer: "cb_2021_us_county_500k-cuyvi1",
      countyProp: "GEOID",
      mapCenter: [-98, 38.88],
      minZoom: 3,
      maxZoom: 10,
      zoom: 3,
    },
    CA: {
      mapboxUrl: "mapbox://codrutaene.6b0ji005",
      sourceLayer: "georef-canada-census-subdivis-9h9an5",
      countyProp: "prov_code",
      mapCenter: [-98, 56],
      minZoom: 2,
      maxZoom: 10,
      zoom: 3,
    },
  },
};

const getters = {
  selectedCountry: (state) => state.selectedCountry,
  countries: (state) => state.countries,
  tilesets: (state) => state.tilesets,
};

const mutations = {
  setSelectedCountry(state, val) {
    state.selectedCountry = { ...val };
  },
  setCountries(state, obj) {
    state.countries = [...obj];
  },
};
const actions = {
  async loadCountries({ rootGetters, commit, dispatch }) {
    // state,
    try {
      const res = await axios.get(
        rootGetters.backendURL + "/api/service_countries"
      );
      // console.log(axios.defaults.headers.common);
      let mappedColorArr = res.data.map((obj) => ({
        ...obj,
        color: state.colorCoding[obj.color_index],
        iso_3166_1: obj.code,
      }));

      commit("setCountries", mappedColorArr);
    } catch (err) {
      console.log(err);
      dispatch("pushNotification", {
        type: "error",
        label: "Get Countries failed",
        text: "Countries unavailable",
        duration: "long",
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
